import { Link } from '@mui/material'
import { NftIcon } from 'src/assets/icons/v2/NftIcon'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { ETransactionType, ETranslationNs } from 'src/types'
import { useStyles } from './styles'
import { ScanIcon } from 'src/assets/icons/v2/ScanIcon'
import { ArwaveIcon } from 'src/assets/icons/v2/ArwaveIcon'

interface IProps {
  type: ETransactionType
  externalUrl: string | null
}

export const ExplorerLink = ({ type, externalUrl }: IProps) => {
  const classes = useStyles()
  return (
    <Link target={'_blank'} href={externalUrl || '#'}>
      {type === ETransactionType.Arweave ? (
        <div className={classes.iconWrapper2}>
          <ArwaveIcon size={24} />
          <div>Arweave</div>
        </div>
      ) : type === ETransactionType.AccountToken ? (
        <div className={classes.iconWrapper2}>
          <NftIcon size={24} />
          <HelperWrapper ns={ETranslationNs.TransactionLogs} t="account-nft-label" />
        </div>
      ) : type === ETransactionType.ProductToken ? (
        <div className={classes.iconWrapper2}>
          <NftIcon size={24} />
          <HelperWrapper ns={ETranslationNs.TransactionLogs} t="product-nft-label" />
        </div>
      ) : type === ETransactionType.ConsumerScan ? (
        <div className={classes.iconWrapper2}>
          <ScanIcon size={24} />
          <HelperWrapper ns={ETranslationNs.TransactionLogs} t="tx-log-consumer-scan-label" />
        </div>
      ) : (
        <div className={classes.iconWrapper2}>
          <ScanIcon size={24} />
          <HelperWrapper ns={ETranslationNs.TransactionLogs} t="tx-log-scan-label" />
        </div>
      )}
    </Link>
  )
}
